/**
 * @generated SignedSource<<a661edeb94c01259c7ba8427b0c79a2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiskCleanupScanInfo_scanInfo$data = {
  readonly count: number;
  readonly size: string;
  readonly " $fragmentType": "DiskCleanupScanInfo_scanInfo";
};
export type DiskCleanupScanInfo_scanInfo$key = {
  readonly " $data"?: DiskCleanupScanInfo_scanInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiskCleanupScanInfo_scanInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiskCleanupScanInfo_scanInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    }
  ],
  "type": "CleanInfo",
  "abstractKey": null
};

(node as any).hash = "251b43cab377ccb1e618439888b78079";

export default node;
